import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

// import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';
import thopsignlogo from '../assets/thopsignlogo.png';
import thopslogo from '../assets/thopslogo.png';
import thops from '../assets/thops.png';
import thops2 from '../assets/thops2.png';
import thops3 from '../assets/thops3.png';
import motor2 from '../assets/motor2.jpg';
import thops4 from '../assets/thops4.png';
import tailwind from '../assets/tailwind.svg';
import next from '../assets/next.svg';
import react from '../assets/react.svg';
import contact from '../assets/contact.png';
import email1 from '../assets/email.svg';






// eslint-disable-next-line
export default {

  contact,
  email1,
  react,
  next,
  tailwind,
  motor2,
  thops,
  thops2,
  thops4,
  thops3,
  thopsignlogo,
  thopslogo,
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  // profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
};
